<template>
  <PortalPageShell
    title="Flight Status Manager"
    :subtitle="$t('portal.statusManager')"
  >
    <ManageStatus
      class="portal-page-fill"
      :direction="direction"
      :sort="sort"
      @updateSort="updateSort"
    />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ManageStatus from '../components/status/ManageStatus.vue';

export default {
  components: {
    PortalPageShell,
    ManageStatus,
  },
  data() {
    return {
      sort: '',
      direction: 'ascending',
    };
  },
  methods: {
    updateSort(value) {
      if (this.sort == value) {
        this.direction = this.direction == 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sort = value;
        this.direction = 'ascending';
      }
    },
  },
};
</script>
